import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-[#2b3545] text-white pt-16 pb-8 px-6 md:px-12 overflow-hidden" data-id="element-267">
      <div className="max-w-7xl mx-auto" data-id="element-268">
        {/* Top Section: Sitemap & Services */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12 mb-16" data-id="element-269">
          {/* Left: Sitemap Links */}
          <nav aria-label="Sitemap" className="flex flex-col" data-id="element-270">
            <span className="text-[#5bbcd5] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-271">
              Sitemap
            </span>
            <div className="font-bebas tracking-wide text-[#8494a7] leading-[0.9]" data-id="element-272">
              <div className="text-5xl md:text-7xl lg:text-[5.5rem]" data-id="element-273">
                <Link to="/" className="hover:text-[#5bbcd5] transition-colors" data-id="element-274">
                  HOME
                </Link>
                <span className="mx-1" data-id="element-275">/</span>
                <span className="hover:text-[#5bbcd5] transition-colors cursor-default" data-id="element-276">
                  OUR SERVICES
                </span>
                <span className="mx-1" data-id="element-277">/</span>
                <Link to="/about-us" className="hover:text-[#5bbcd5] transition-colors" data-id="element-278">
                  ABOUT US
                </Link>
              </div>
              <div className="text-5xl md:text-7xl lg:text-[5.5rem] mt-1" data-id="element-279">
                <Link to="/contact-us" className="hover:text-[#5bbcd5] transition-colors" data-id="element-280">
                  CONTACT US
                </Link>
                <span className="mx-1" data-id="element-281">/</span>
                <Link to="/faq" className="hover:text-[#5bbcd5] transition-colors" data-id="element-282">
                  FAQ
                </Link>
              </div>
            </div>
          </nav>

          {/* Right: Services List */}
          <div className="flex flex-col items-end text-right mt-4 lg:mt-0" data-id="element-283">
            <span className="text-[#5bbcd5] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-284">
              Services
            </span>
            <ul className="font-bebas text-[#8494a7] text-2xl md:text-3xl lg:text-4xl tracking-wide leading-tight space-y-1" data-id="element-285">
              <li data-id="element-286">
                <Link to="/commercial-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-287">
                  COMMERCIAL CLEANING
                </Link>
              </li>
              <li data-id="element-288">
                <Link to="/basic-home-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-289">
                  BASIC HOME CLEANING
                </Link>
              </li>
              <li data-id="element-290">
                <Link to="/spring-deep-cleaning" className="hover:text-[#5bbcd5] transition-colors" data-id="element-291">
                  SPRING / DEEP CLEANING
                </Link>
              </li>
              <li data-id="element-292">
                <Link to="/move-in-move-out-quote" className="hover:text-[#5bbcd5] transition-colors" data-id="element-293">
                  MOVE-IN / MOVE-OUT
                </Link>
              </li>
              <li data-id="element-294">
                <Link to="/airbnb-quote" className="hover:text-[#5bbcd5] transition-colors" data-id="element-295">
                  AIRBNB / SHORT TERM RENTAL
                </Link>
              </li>
              <li data-id="element-296">
                <Link to="/post-renovation-quote" className="hover:text-[#5bbcd5] transition-colors" data-id="element-297">
                  POST RENOVATION
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Middle Section: Logo & Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-end gap-8 mb-8" data-id="element-298">
          {/* Left: Logo */}
          <div className="flex flex-col items-start" data-id="element-299">
            <img src="https://cdn.magicpatterns.com/uploads/1h9RWLFQ7TTAoyFwfGSDao/sj-website-logo-white.svg" alt="Smith & Jengs Cleaning Services" className="w-24 h-24 object-contain mb-4" width={96} height={96} loading="lazy" decoding="async" data-id="element-300" />
            <img src="https://cdn.magicpatterns.com/uploads/9gJT63RaUddpyfpZWktWUn/sj-website-sj-text-stacked-white.svg" alt="Smith & Jengs" className="w-48 md:w-56 h-auto" width={224} height={80} loading="lazy" decoding="async" data-id="element-301" />
          </div>

          {/* Right: Copyright & Legal */}
          <div className="flex flex-col items-end text-right text-sm text-gray-400" data-id="element-302">
            <span data-id="element-303">© 2026 Smith & Jengs</span>
            <div className="flex gap-2 mt-1" data-id="element-304">
              <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-305">
                Privacy Policy
              </Link>
              <span data-id="element-306">/</span>
              <a href="#" className="hover:text-white transition-colors" data-id="element-307">
                Terms and Conditions
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Contact Info */}
        <div className="border-t border-white/10 pt-6" data-id="element-308">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-0 text-sm text-white/80" data-id="element-309">
            <span data-id="element-310">
              <span className="font-semibold" data-id="element-311">email:</span>{' '}
              <a href="mailto:smithsandjengs@yahoo.com" className="hover:text-[#5bbcd5] transition-colors" data-id="element-312">
                smithsandjengs@yahoo.com
              </a>
            </span>
            <span className="hidden md:inline mx-6 text-white/30" data-id="element-313">/</span>
            <span data-id="element-314">
              <span className="font-semibold" data-id="element-315">phone:</span>{' '}
              <a href="tel:07432285564" className="hover:text-[#5bbcd5] transition-colors" data-id="element-316">
                07432285564
              </a>
              <span className="mx-2" data-id="element-317">|</span>
              <a href="tel:01869601439" className="hover:text-[#5bbcd5] transition-colors" data-id="element-318">
                01869601439
              </a>
            </span>
            <span className="hidden md:inline mx-6 text-white/30" data-id="element-319">/</span>
            <span data-id="element-320">
              <span className="font-semibold" data-id="element-321">facebook:</span>{' '}
              <a href="https://www.facebook.com/SmithandJengs/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5bbcd5] transition-colors" data-id="element-322">
                smithsandjengs
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}